import FontFaceObserver from "fontfaceobserver";

var Raleway = new FontFaceObserver("Raleway");
var Playfair = new FontFaceObserver("Playfair Display");

Promise.all([Raleway.load(), Playfair.load()]).then(function () {
    document.documentElement.classList.add("fonts-loaded");
});
